export default __webpack_public_path__ + "static/media/left-arrow.18157d2a.svg";